var React = require('react');

function OnePlus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.447 0L0 4.25v14.097l3.98-.673v27.225h19.632V3.866L14.447 0zM3 14.797V6.495l9.755-2.87v38.274H6.98V14.124L3 14.797zM15.755 41.9V3.808l4.857 2.048V41.9h-4.857zM31.625.899v5.625H26v9.75h5.625v5.625h9.75v-5.625H47v-9.75h-5.625V.899h-9.75zm3 3h3.75v5.625H44v3.75h-5.625v5.625h-3.75v-5.625H29v-3.75h5.625V3.899z"}));
}

OnePlus.defaultProps = {"viewBox":"0 0 47 45"};

module.exports = OnePlus;

OnePlus.default = OnePlus;
